import { Box } from "@mui/material";
import TextInput from "../../theme/inputs/TextInput";
import cx from 'classnames';
import { textValueTypes } from "./ConditionSettings";

export const CRValueInput = ({ ruleline, index, selectRuleLineValue, errorMap, colors }) => {
  const hasError = errorMap && errorMap[index] && errorMap[index].value;

  return (
    <Box
      className={cx('', { error: hasError })}
      sx={{
        display: "inline-flex",
        ml: "auto",
        background: colors.grey[100],
        height: 32,
        borderRadius: 4,
        width: 120,
        "&:hover": {
          background: colors.grey[200],
          cursor: "pointer",
        },
        "&.error": {
          background: colors.red[100],
        },
      }}
    >
      <TextInput
        type={textValueTypes.includes(ruleline.valueType) ? "text" : "number"}
        value={ruleline.value}
        background="transparent"
        onChange={(e) => selectRuleLineValue(e.target.value, index)}
      />
    </Box>
  );
};
